import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckStatusController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckStatusController.php
* @route '/api/fetch-check-status'
*/
const GetCheckStatusController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckStatusController.url(options),
    method: 'get',
})

GetCheckStatusController.definition = {
    methods: ["get","head"],
    url: '/api/fetch-check-status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckStatusController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckStatusController.php
* @route '/api/fetch-check-status'
*/
GetCheckStatusController.url = (options?: RouteQueryOptions) => {
    return GetCheckStatusController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckStatusController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckStatusController.php
* @route '/api/fetch-check-status'
*/
GetCheckStatusController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCheckStatusController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CheckDeposit\GetCheckStatusController::__invoke
* @see app/Http/Controllers/CheckDeposit/GetCheckStatusController.php
* @route '/api/fetch-check-status'
*/
GetCheckStatusController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCheckStatusController.url(options),
    method: 'head',
})

export default GetCheckStatusController